import { t } from '@lingui/macro';
import {
  Settings,
  Database,
  MessageCircle,
  CheckCircle2,
  PlayCircle,
  Lightbulb,
  Users,
  Globe,
  Code2,
  MessageSquare,
  ArrowLeft
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from '../../hooks/useRouterCompat';
import Page from '../../const/Page';
import { useAppUIContext } from '../../context/AppUIContext';
import { Soribot } from '../../models/Soribot';
import { UtilApp } from '../../services/Utils/UtilApp';
import { SoribotSettingPage } from './SoribotSettingPage';
import { Button } from '../../components/ui/button';
import { cn } from '../../lib/utils';

const LeftMenuSoribot: React.FC = () => {
  const [currentPath, setCurrentPath] = useState<string>();
  const { soribots } = useAppUIContext();
  const botId = UtilApp.getLastPathSegment();
  const [bot, setBot] = useState<Soribot | null>();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    setBot(soribots.find(b => b.id === botId));
  }, [botId, soribots]);

  return (
    <div className="flex flex-col h-full bg-muted/50 border-r">
      <div className="h-14 flex items-center px-4 border-b bg-background gap-2">
        <Button
          variant="ghost"
          size="sm"
          className="gap-2 -ml-2 text-muted-foreground hover:text-foreground"
          onClick={() => history.push(Page.my_soribots)}
        >
          <ArrowLeft className="w-4 h-4" />
          {t`Back`}
        </Button>
        {bot && <span className="text-sm font-semibold truncate ml-auto">{bot.name}</span>}
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="p-2 space-y-1">
          {SideButton('details', Settings, t`Details`)}
          {SideButton('datasources', Database, t`Data sources`)}
          {SideButton('freechat', MessageCircle, t`Free chat`)}
          {SideButton('testcases', CheckCircle2, t`Test cases`)}
          {SideButton('testruns', PlayCircle, t`Test runs`)}
          {SideButton('suggestions', Lightbulb, t`Suggestions`)}
          {SideButton('rooms', Users, t`Channels`)}
          {SideButton('public', Globe, t`Public page`)}
          {SideButton('api', Code2, t`Exposed API`)}
          {SideButton('messages', MessageSquare, t`Messages`)}
        </div>
      </div>
    </div>
  );

  function SideButton(p: SoribotSettingPage, Icon: React.ElementType, text: string) {
    const isSelected = currentPath?.includes(`/${p}/`);
    return (
      <Button
        variant={isSelected ? "secondary" : "ghost"}
        className={cn(
          "w-full justify-start gap-3 px-3 font-normal",
          isSelected && "font-medium"
        )}
        onClick={() => history.replace(`/soribot/${p}/${bot?.id}`)}
      >
        <Icon className="w-4 h-4" />
        {text}
      </Button>
    )
  }
};


export default LeftMenuSoribot;

